import React from "react";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ErrorFallBack from "../../Vistes/PantallesBKI/ErrorFallBack.js";

/* PANTALLAS BKI */
import TablaLogsEnviamentsView from "../../Vistes/PantallesBKI/TablaLogsEnviamentsView";
import TablaPropertiesView from "../../Vistes/PantallesBKI/TablaPropertiesView";
import Trazabilidad from "../../Vistes/PantallesBKI/Trazabilidad";
import DetallTramits from "../../Vistes/PantallesBKI/DetallTramits";
import MantenimentMetataula from "../../Vistes/PantallesBKI/MantenimentMetataula";
import TablaControlTramitsView from "../../Vistes/PantallesBKI/TablaControlTramitsView";
import TablaPathXMLView from "../../Vistes/PantallesBKI/TablaPathXMLView";
import ModificarCoordenades from "../../Vistes/RDAC/ModificarCoordenades";
import ConsultarDAs from "../../Vistes/RDAC/ConsultarDAs";
import AccessDeniedPage from "../../Vistes/PantallesBKI/AccessDeniedPage.js";
import FormPeticioInformacio from "../../Vistes/Requeriment/FormPeticioInformacio/FormPeticioInformacio.js";
import DadesPeticio from "../../Vistes/Requeriment/DadesPeticio/DadesPeticio.js";
import Authenticator from "../../Vistes/PantallesBKI/Authenticator.js";
import Home from "../../Vistes/PantallesBKI/Home.js";

/*Contextos*/
import { TraceFiltersProvider } from "../../contexts/trazabilidad/TraceFiltersContext.js";
import {
  getAuthToken,
  isValidToken,
  removeAuthToken,
} from "../../security/tokenUtils.js";
import { URL_APP } from "../../constants/URL.js";
import UnathenticatedPage from "../../Vistes/PantallesBKI/UnathenticatedPage.js";

const checkAuthorization = async (jsonData, location) => {
  if (jsonData && Object.keys(jsonData).length > 0) {
    return jsonData;
  } else if (location === "") {
    throw new Error("Access Denied");
  } else {
    return null; // or handle loading state
  }
};

const checkAuthentication = () => {
  const isTokenValid = isValidToken(getAuthToken());

  if (!isTokenValid) {
    removeAuthToken();
    return Promise.reject("Access Denied");
  }

  return Promise.resolve();
};

function AuthRouter({ jsonData, location }) {
  const router = createBrowserRouter([
    {
      path: URL_APP.BASE,
      element: <Home />,
    },
    {
      path: URL_APP.AUTHENTICATOR,
      element: <Authenticator />,
    },
    {
      path: "/ModificarCoordenades",
      element: <ModificarCoordenades json={jsonData} />,
      loader: async () => checkAuthorization(jsonData, location),
      errorElement: <AccessDeniedPage />,
    },
    {
      path: "/ConsultarDAs",
      element: <ConsultarDAs />,
      loader: async () => checkAuthorization(jsonData, location),
      errorElement: <AccessDeniedPage />,
    },
    {
      path: "/LogsEnviamentsPRE",
      element: <TablaLogsEnviamentsView />,
    },
    {
      path: "/TablaProperties",
      element: <TablaPropertiesView />,
    },
    {
      path: "/Trazabilidad",
      element: (
        <TraceFiltersProvider>
          <Trazabilidad />
        </TraceFiltersProvider>
      ),
      loader: checkAuthentication,
      errorElement: <ErrorFallBack />,
    },
    {
      path: "/DetallTramits",
      element: <DetallTramits />,
    },
    {
      path: "/MantenimentMetataula",
      element: <MantenimentMetataula />,
    },
    {
      path: "/ControlTramits",
      element: <TablaControlTramitsView />,
    },
    {
      path: "/ConsultaPathsXML",
      element: <TablaPathXMLView />,
    },
    {
      path: "/dadesPeticio",
      element: <DadesPeticio />,
    },
    {
      path: "/requeriment",
      element: <FormPeticioInformacio />,
    },
    {
      path: URL_APP.ERROR,
      element: <ErrorFallBack />,
    },
    {
      path: URL_APP.UNATHENTICATED,
      element: <UnathenticatedPage />,
    },
  ]);

  return <RouterProvider router={router} />;
}

export default AuthRouter;
